import Helper from '@ember/component/helper';

export function errorFor([errors, index, errorKey]) {
  if (errors[index]) {
    return errors[index][errorKey];
  }
}

export default Helper.helper(errorFor);
